
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_BETA_REQUEST,
  fetchBetaTimeRequest,
  fetchBetaTimeSuccess,
  fetchBetaTimeFailure,
  UPLOAD_BETA_EMAIL_REQUEST,
  uploadBetaEmailSuccess,
  uploadBetaEmailFailure,
  SEARCH_BETA_EMAIL_REQUEST_REQUEST,
  searchiOSBetaSuccess,
  searchiOSBetaFailure
} from './betaEmailAction';
import SDK from '../../../config';

// Fetch beta email data saga
function* fetchBetaEmail(action) {
  const { page, limit } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/api/iOS/beta/subscriber?page=${page}&limit=${limit}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = yield response.json();
    yield put(fetchBetaTimeSuccess(data.data));
  } catch (error) {
    yield put(fetchBetaTimeFailure(error.toString()));
  }
}

// Search beta email data saga
function* searchBetaEmailsIssue(action) {
  const { searchTerm } = action.payload;
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/api/iOS/search/iOSBeta/emails?searchTerm=${searchTerm}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = yield response.json();
    yield put(searchiOSBetaSuccess(data.data));
  } catch (error) {
    console.error('Fetch error:', error);
    yield put(searchiOSBetaFailure(error.toString()));
  }
}

// Upload beta email saga
function* uploadBetaEmail(action) {
  try {
    const response = yield call(fetch, `${SDK.SOCKET_URL}/api/iOS/beta/subscriber/single`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: action.payload }),
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    yield put(uploadBetaEmailSuccess());
    yield put(fetchBetaTimeRequest());
  } catch (error) {
    yield put(uploadBetaEmailFailure(error.toString()));
  }
}


function* betaEmailSaga() {
  yield takeLatest(FETCH_BETA_REQUEST, fetchBetaEmail);
  yield takeLatest(UPLOAD_BETA_EMAIL_REQUEST, uploadBetaEmail);
  yield takeLatest(SEARCH_BETA_EMAIL_REQUEST_REQUEST, searchBetaEmailsIssue);
}

export default betaEmailSaga;
